import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Player from "../components/Player/Player";
import { useStateContext } from "../contexts/ContextProvider";

import MobileBanner from "../components/NativeBanner/MobileBanner";
import DesktopBanner from "../components/NativeBanner/DesktopBanner";

function App() {
  const navigate = useNavigate();
  const { contestId, id } = useParams();
  const { songs, loading, getSongs, currentRound } = useStateContext();
  const [currentSongIndex, setCurrentSongIndex] = useState(parseInt(id) - 1);
  const [nextSongIndex, setNextSongIndex] = useState(parseInt(id));
  const [isMobile, setIsMobile] = useState(true);

  const getLocalStorage = () => {
    for (let i = 1; i <= 5; i++) {
      let contestData = localStorage.getItem(
        `${contestId.toString()}_${currentRound}`
      );
      let contestDataValue = JSON.parse(contestData);
      // console.log("contestData: " + contestData);

      if (contestDataValue) {
        if (i === 5) {
          navigate(`/final/${contestId}`);
        }
      }
      if (contestDataValue) {
        if (!contestDataValue[i.toString()]) {
          switch (i) {
            case 1: // SongPage
              navigate(`/song/${i}/${contestId}`);
              break;
            case 2: // SongPage
              navigate(`/song/${i + 1}/${contestId}`);
              break;
            case 3: // SongPage
              navigate(`/song/${i + 2}/${contestId}`);
              break;
            case 4: // SongPage
              navigate(`/song/${i + 3}/${contestId}`);
              break;
            default:
          }
          break;
        }
      }
    }
  };

  useEffect(() => {
    if (!window.matchMedia("(max-width: 688px)").matches) {
      setIsMobile(false);
    }
    getSongs(contestId);
    getLocalStorage();
    setNextSongIndex(() => {
      if (currentSongIndex + 1 > songs.length - 1) {
        return 0;
      } else {
        return currentSongIndex + 1;
      }
    });
  }, [currentSongIndex, currentRound, contestId]);

  return (
    <>
      {isMobile ? <MobileBanner /> : <DesktopBanner />}
      {(loading || songs.length === 0 || currentRound === 0) && (
        <div className="flex justify-center items-center bg-blue-600">
          <p className="text-white text-lg">Loading...</p>
        </div>
      )}
      {songs.length > 0 && (
        <div className="App">
          {0 < id && id - 1 < songs.length ? (
            <>
              <Player
                currentSongIndex={id - 1}
                setCurrentSongIndex={setCurrentSongIndex}
                nextSongIndex={id}
                songs={songs}
              />
            </>
          ) : (
            <>{navigate(`/final/${contestId}`)}</>
          )}
        </div>
      )}
    </>
  );
}

export default App;
